"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG = void 0;
const properties_1 = require("@ethersproject/properties");
exports.CONFIG = Object.assign(Object.assign({}, (0, properties_1.deepCopy)(process.env.CONFIG)), { scannerUrl: {
        "56": "https://bscscan.com",
        "97": "https://testnet.bscscan.com",
    } });
